import '../AcmgReportStatus.css';
import React from 'react';
import AppHeader from "./AppHeader";
import dnaSvg from "../static/dna_asset.svg";
import formSvg from "../static/library_asset.svg";
import pillSvg from "../static/form_asset.svg";
import tubeSvg from "../static/tube_asset.svg";
import AcmgReportStatusRow from "./AcmgReportStatusRow";
import {AcmgStatusObject} from "../utils/AcmgStatusObject";
import {isRTL, Languages, useLanguage} from "../LanguageContext";
import {getTranslation} from "../consts/translations";

interface AcmgReportStatusProps {
    acmgReportStatus: AcmgStatusObject,
    setAcmgReportStatus: (reportStatus: AcmgStatusObject) => void
}

interface ReportStatusItem {
    svgIcon: string;
    label: string;
}


const AcmgReportStatus: React.FC<AcmgReportStatusProps> = (props: AcmgReportStatusProps) => {
    const {language} = useLanguage();
    const translation = getTranslation(language);

    const reportStatusItems: ReportStatusItem[] = [
        {svgIcon: tubeSvg, label: translation.acmg_status_sample_obtained_label},
        {svgIcon: dnaSvg, label: translation.acmg_status_sequencing_label},
        {svgIcon: formSvg, label: translation.acmg_status_report_creation_label},
        {svgIcon: pillSvg, label: translation.acmg_status_received_report_label}
    ];


    const paragraphDirection: React.CSSProperties = {
        textAlign: isRTL(language) ? 'right' : 'left',
    };
    const statusDescription = (() => {
        switch (language) {
            case Languages.ENGLISH:
                return props.acmgReportStatus.description.English;
            case Languages.ARABIC:
                return props.acmgReportStatus.description.Arabic;
            case Languages.RUSSIAN:
                return props.acmgReportStatus.description.Russian;
            case Languages.HEBREW:
            default:
                return props.acmgReportStatus.description.Hebrew;
        }
    })();

    return (
        <div className="acmg-report-status-container">
            <div className="status-background-image"/>
            <AppHeader
                subtitle={translation.acmg_status_title}
                height="224px"
            />
            <div className="acmg-report-status-content">
                <div className="statuses-list">
                    {reportStatusItems.map((item: ReportStatusItem, index: number) => (
                        <AcmgReportStatusRow
                            key={index}
                            index={index}
                            svgIcon={item.svgIcon}
                            label={item.label}
                            checked={index === props.acmgReportStatus.status}
                        />
                    ))}

                    {statusDescription &&
                        <div className="status-description">{statusDescription}</div>
                    }
                </div>

                <div className="thank-you-text">{translation.acmg_status_thanks_text}</div>
                <p className="disclaimer-paragraph"
                   style={paragraphDirection}>{translation.disclaimer_paragraph_first}</p>
                <p className="disclaimer-paragraph"
                   style={paragraphDirection}>{translation.disclaimer_paragraph_second}</p>
            </div>
        </div>
    );
}

export default AcmgReportStatus;
